import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getIntegratedDrivesBundles, getProductInformations } from "../../utils/common/api/api";
// import { BUNDLES_EXAMPLE } from "../../store/data/integratedDrivesData";

export const useGetIntegratedDrivesBundles = (filters, paging, resetPaging, orderBy, sncWidgetOutput) => {
  const [fetchedBundles, setFetchedBundles] = useState([]);
  const [countOfBundles, setCountOfBundles] = useState(0);

  const lang = window.msizerConfiguration?.locale || "en-WW";

  const {
    refetch: fetchBundles,
    isLoading,
    isFetching
  } = useQuery(
    "FETCH_INTEGRATED_DRIVES_BUNDLES",
    async () => {
      try {
        // if the gearbox is not enabled, we return one single bundle without gearbox and adaptation kit
        console.log("filters", filters);
        const isGearboxEnabled = filters?.gearboxFilter?.enabled;
        if (!isGearboxEnabled) {
          setCountOfBundles(1);
          const bundles = [
            {
              id: "no-gearbox-" + sncWidgetOutput?.extras?.codification,
              integratedDrive: sncWidgetOutput
            }
          ];
          setFetchedBundles(bundles);
        } else {
          setCountOfBundles(0);
          const payload = {
            locale: lang,
            paging,
            search: {
              ...filters,
              gearboxFilter: {
                manufacturer: undefined,
                type: filters?.gearboxFilter.gearboxType?.length > 0 ? filters?.gearboxFilter.gearboxType : undefined,
                precision: undefined,
                reductionRatio: filters?.gearboxFilter.ratio.length > 0 ? filters?.gearboxFilter.ratio : undefined,
                specification: undefined,
                efficiency:
                  filters?.gearboxFilter.efficiency?.length > 0 ? filters?.gearboxFilter.efficiency : undefined,
                productOrComponentType:
                  filters?.gearboxFilter.productOrComponentType?.length > 0
                    ? filters?.gearboxFilter.productOrComponentType
                    : undefined,
                torsionalBacklash: filters?.gearboxFilter?.torsionalBacklash,
                inputDiameter:
                  filters?.gearboxFilter.inputDiameter?.length > 0 ? filters?.gearboxFilter.inputDiameter : undefined,
                externalDiameter:
                  filters?.gearboxFilter.externalDiameter?.length > 0
                    ? filters?.gearboxFilter.externalDiameter
                    : undefined
              }
            }
            // order: orderBy
          };
          const response = await getIntegratedDrivesBundles(payload);
          // console.log("sncWidgetOutput", sncWidgetOutput);
          const { bundles } = response;
          setCountOfBundles(response.countOfResults);
          if (bundles) {
            // get the list of ids of each gearbox and adaptation kits
            let gearboxIds = [];
            let adaptationKitIds = [];
            bundles.forEach((bundle) => {
              gearboxIds.push(bundle.gearbox?.commercialReference);
              adaptationKitIds.push(bundle.adaptationKit?.commercialReference);
            });
            //delete duplicates
            gearboxIds = Array.from(new Set(gearboxIds));
            adaptationKitIds = Array.from(new Set(adaptationKitIds));

            // call the schneider's api for translation
            const gearboxInfosTranslated = await getProductInformations(gearboxIds);
            const adaptationKitInfosTranslated = await getProductInformations(adaptationKitIds);
            // add translation informations to bdls object
            bundles.forEach((bundle) => {
              if (bundle.gearbox) {
                bundle.gearbox.translationData = gearboxInfosTranslated?.filter(
                  (elt) => elt?.catalogue_product?.id === bundle?.gearbox?.commercialReference
                );
              }
              if (bundle.adaptationKit) {
                bundle.adaptationKit.translationData = adaptationKitInfosTranslated?.filter(
                  (elt) => elt?.catalogue_product?.id === bundle.adaptationKit?.commercialReference
                );
              }
            });
            const updatedBundles = bundles?.map((bundle) => ({
              ...bundle,
              id: bundle.gearbox?.commercialReference + "-" + bundle.adaptationKit?.commercialReference,
              integratedDrive: sncWidgetOutput
            }));
            console.log("updatedBundles", updatedBundles);
            setFetchedBundles(updatedBundles);
          }
        }
      } catch (error) {
        console.error(error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  // const queryClient = useQueryClient();

  // useEffect(() => {
  //   // when the filters change, we need to refetch the bundles and cancel the previous request
  //   queryClient.cancelQueries("FETCH_INTEGRATED_DRIVES_BUNDLES");
  //   fetchBundles();
  // }, [filters]);

  const [withGearbox, setWithGearbox] = useState(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);

  useEffect(() => {
    setWithGearbox(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);
    resetPaging();
  }, [filters]);

  // when the filters change and filters wrapper is closed and !editingAxis => fetch bundles from api
  useEffect(() => {
    // check drive filters function
    const checkDriveFilters = () => {
      return (
        filters?.driveFilter?.driveInterface?.length > 0 &&
        filters?.driveFilter?.driveInterface?.[0] !== "" &&
        filters?.driveFilter?.nbPhases?.length > 0 &&
        filters?.driveFilter?.nbPhases?.[0] !== "" &&
        filters?.driveFilter?.driveVoltages?.length > 0 &&
        filters?.driveFilter?.driveVoltages?.[0] !== ""
      );
    };

    // check motor filters function
    const checkMotorFilters = () => {
      return (
        filters?.motorFilter?.ipDegreeOfProtection?.length > 0 &&
        filters?.motorFilter?.holdingBrake?.length > 0 &&
        (!withGearbox || filters?.gearboxFilter?.productOrComponentType?.length > 0)
      );
    };

    // check gearbox filters function
    const checkGearboxFilters = () => {
      return !withGearbox || filters?.gearboxFilter?.productOrComponentType?.length > 0;
    };

    // if filters?.driveFilter object is not empty then check if all mandatory filters are filled
    const driveFiltersApplicable = filters?.driveFilter !== undefined && filters?.driveFilter !== null;

    // if filters?.motorFilter object is not empty then check if all mandatory filters are filled
    const motorFiltersApplicable = filters?.motorFilter !== undefined && filters?.motorFilter !== null;

    // if filters?.gearboxFilter object is not empty then check if all mandatory filters are filled
    const gearboxFiltersApplicable = filters?.gearboxFilter !== undefined && filters?.gearboxFilter !== null;

    if (
      (!driveFiltersApplicable || checkDriveFilters()) &&
      (!motorFiltersApplicable || checkMotorFilters()) &&
      (!gearboxFiltersApplicable || checkGearboxFilters())
    ) {
      fetchBundles();
    }
    console.log("filters changed", paging);
  }, [filters, paging, orderBy]);

  return {
    isFetching: isFetching || isLoading,
    refetch: fetchBundles,
    bundles: fetchedBundles,
    countOfBundles: countOfBundles
  };
};
